import React, { useEffect, useState } from "react";
import "./style.css";
import Button from "../../../../shared/ui/inputs/classicButton.js";
import { download } from "../../../order/components/downloadableFileItem/downloadableFileItem.js";
import { useInView } from "react-intersection-observer";
export default function Image(props) {
    const [ref, inView] = useInView({
        rootMargin: "200px",
    });
    const [loaded, setLoaded] = useState(false);
    const [src, setSrc] = useState("");
    useEffect(() => {
        setLoaded(false);
        setSrc(`/api/public/collectionClient/collection/image/${props.name}/class/preview`);
    }, [props.name, props.aspectRatio]);
    useEffect(() => {
        if (inView == false)
            return;
        setSrc(`/api/public/collectionClient/collection/image/${props.name}/class/preview`);
    }, [inView]);
    return (React.createElement("div", { className: !loaded ? "image-container image-container-loading" : "image-container", ref: ref, style: {
            aspectRatio: props.aspectRatio + "",
        } },
        React.createElement("img", { className: "image-view", src: src, style: {
                aspectRatio: props.aspectRatio + "",
            }, onLoad: () => setLoaded(true), loading: "lazy" }),
        React.createElement(Button, { text: "", value: "download-file", classNames: "download-button", onClick: async () => {
                await download(`/api/public/collectionClient/collection/image/${props.name}/class/full`, props.name);
            } },
            React.createElement("img", { src: "/assets/icons/download-file-icon.svg", width: "24" }))));
}
